import { IconButton } from '@hub/button'
import { HamburgerMediumIcon } from '@hub/icon'
import { useToken, HubStyleObject } from '@hub/design-system-base'
import React from 'react'

interface HamburgerButtonProps {
  onToggle: () => void
  menuId: string
  expanded: boolean
  sx?: HubStyleObject
}

export const HamburgerButton: React.FC<HamburgerButtonProps> = ({
  onToggle,
  menuId,
  expanded,
  sx,
}) => {
  const hitTargetGrowthX = useToken('space', 'spacing-sm')

  const HamburgerIconButtonAs = React.forwardRef<HTMLButtonElement>(
    (props, ref) => (
      <button
        aria-controls={menuId}
        aria-owns={menuId}
        aria-expanded={expanded}
        {...props}
        ref={ref}
      />
    )
  )
  HamburgerIconButtonAs.displayName = 'HamburgerIconButtonAs'

  return (
    <IconButton
      as={HamburgerIconButtonAs}
      icon={<HamburgerMediumIcon boxSize="size-icon-md" />}
      aria-label="Open Secondary Navigation"
      sx={{
        ...sx,
        position: 'relative',
        backgroundColor: 'transparent',
        minWidth: 'initial',
        // Increase the hit target of the button
        '&:before': {
          content: '""',
          position: 'absolute',
          left: `-${hitTargetGrowthX}`,
          right: `-${hitTargetGrowthX}`,
          top: 0,
          bottom: 0,
        },
      }}
      onClick={onToggle}
    />
  )
}
